import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=4ec93da6&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=ts&"
export * from "./BaseAlert.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=4ec93da6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec93da6",
  null
  
)

export default component.exports